<template>
    <div>
      <h1 class="text-success">Formulario para el Tipo Vacuna</h1>
      <div class="alert alert-info" role="alert">
      <strong>Nota:</strong> Este formulario agregará nombres acerca del tipo vacuna en el Esquema de vacunación para
embarazadas.
    </div>

      <div class="mt-4">
        <button @click="showCreateForm" class="btn btn-primary">Agregar nombre del tipo vacuna</button>
      </div>
  
      <!-- Lista de VacunaTipoMujer en una tabla -->
      <div class="table-responsive mt-3">
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th>Nombre del Tipo Vacuna</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="vacunaTipoMujer in vacunaTipoMujerList" :key="vacunaTipoMujer._id">
              <td>{{ vacunaTipoMujer.tipo }}</td>
              <td>
                <div class="btn-group" role="group">
                  <button @click="editVacunaTipoMujer(vacunaTipoMujer)" class="btn btn-warning btn-sm">Editar</button>
                  <button @click="deleteVacunaTipoMujer(vacunaTipoMujer._id)" class="btn btn-danger btn-sm">Eliminar</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Formulario de creación/editar -->
      <div v-if="showForm" class="mt-4">
        <h2 class="h4">{{ isEditing ? 'Editar VacunaTipoMujer' : 'Agregar VacunaTipoMujer' }}</h2>
        <form @submit.prevent="isEditing ? updateVacunaTipoMujer() : createVacunaTipoMujer()" class="form-inline">
          <div class="form-group mr-2">
            <label for="tipo" class="mr-2">Tipo</label>
            <input v-model="formData.tipo" type="text" id="tipo" required class="form-control form-control-lg" />
          </div>
          <div class="btn-group">
            <button type="submit" class="btn btn-primary">{{ isEditing ? 'Guardar Cambios' : 'Agregar' }}</button>
            <button @click="cancelEdit" class="btn btn-secondary">Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import swal from 'sweetalert';
  import { BASE_URL } from '../store/config';
  
  export default {
    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
    },
    data() {
      return {
        vacunaTipoMujerList: [],
        showForm: false,
        formData: {
          tipo: '',
        },
        isEditing: false,
        editingVacunaTipoMujerId: null,
      };
    },
    methods: {
      async fetchVacunaTipoMujer() {
        try {
          const response = await axios.get(`${BASE_URL}/api/vacunamujertipo`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          this.vacunaTipoMujerList = response.data;
        } catch (error) {
          console.error('Error al obtener VacunaTipoMujer:', error);
        }
      },
      showCreateForm() {
        this.showForm = true;
        this.isEditing = false;
        this.formData = {
          tipo: '',
        };
      },
      async createVacunaTipoMujer() {
        try {
          await axios.post(`${BASE_URL}/api/vacunamujertipo`, this.formData, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Guardada!',
            text: 'La información de VacunaTipoMujer ha sido guardada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.clearFields();
          this.fetchVacunaTipoMujer();
          this.showForm = false;
        } catch (error) {
          swal({
            title: 'Error',
            text: `Hubo un error al guardar la información de VacunaTipoMujer. \n ${error.response.data.message}.`,
            icon: 'error',
            button: 'OK',
          });
        }
      },
      clearFields() {
        this.formData = {
          tipo: '',
        };
      },
      deleteVacunaTipoMujer(id) {
        swal({
          title: '¿Estás seguro?',
          text: 'Una vez eliminado, no podrás recuperar este registro.',
          icon: 'warning',
          buttons: ['Cancelar', 'Eliminar'],
          dangerMode: true,
        })
        .then((confirmation) => {
          if (confirmation) {
            this.performVacunaTipoMujerDeletion(id);
          }
        });
      },
      async performVacunaTipoMujerDeletion(id) {
        try {
          await axios.delete(`${BASE_URL}/api/vacunamujertipo/${id}`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Eliminada!',
            text: 'La información de VacunaTipoMujer ha sido eliminada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.fetchVacunaTipoMujer();
        } catch (error) {
          swal({
            title: 'Error',
            text: 'Hubo un error al eliminar la información de VacunaTipoMujer.',
            icon: 'error',
            button: 'OK',
          });
        }
      },
      editVacunaTipoMujer(vacunaTipoMujer) {
        this.isEditing = true;
        this.editingVacunaTipoMujerId = vacunaTipoMujer._id;
        this.formData.tipo = vacunaTipoMujer.tipo;
        this.showForm = true;
      },
      async updateVacunaTipoMujer() {
        try {
          await axios.put(`${BASE_URL}/api/vacunamujertipo/${this.editingVacunaTipoMujerId}`, this.formData, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          swal({
            title: '¡Información Actualizada!',
            text: 'La información de VacunaTipoMujer ha sido actualizada correctamente.',
            icon: 'success',
            button: 'OK',
          });
          this.clearFields();
          this.fetchVacunaTipoMujer();
          this.showForm = false;
        } catch (error) {
          swal({
            title: 'Error',
            text: `Hubo un error al editar la información de VacunaTipoMujer. \n ${error.response.data.message}.`,
            icon: 'error',
            button: 'OK',
          });
        }
      },
      cancelEdit() {
        this.showForm = false;
        this.isEditing = false;
        this.clearFields();
      },
    },
    mounted() {
      this.fetchVacunaTipoMujer();
    },
  };
  </script>
  
  <style scoped>
  /* Estilos adicionales si es necesario */
  </style>
  